import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../http";
import { serializeDate } from "../utils/date";
import type { DateRangeFilter } from "../utils/date";

export type TokenStats = {
  AI_DETECTION: number;
  SOURCE_DETECTION: number;
  WRITING_ANALYSIS: number;
  QUILLBOT_ANALYSIS: number;
  AI_DETECTION_HIGHLIGHTER: number;
  PLAGIARISM: number;
  HUMANIZER: number;
  AI_WRITER: number;
  REWRITE: number;
  SUMMARIZE: number;
  EXPAND: number;
  SHORTEN: number;
  ADD_CONTENT: number;
  PII_TEXT_DETECT: number;
};

async function getTokenStats({ from_date, to_date }: DateRangeFilter) {
  const searchParams = {
    from_date: serializeDate(from_date),
    to_date: serializeDate(to_date ?? from_date),
  };
  return await api.detector.get<TokenStats>("ai-detector/get-token-stats", {
    searchParams,
  });
}

export const tokenStatsQueryOptions = (filter: DateRangeFilter) =>
  queryOptions({
    queryKey: ["user", "tokenStats", filter],
    async queryFn() {
      const res = await getTokenStats(filter);
      const data = await res.json();

      return { res, data };
    },
    select(data) {
      return data.data;
    },
  });

export function useTokenStats(filter: DateRangeFilter) {
  return useQuery(tokenStatsQueryOptions(filter));
}
